import { useTranslation } from 'react-i18next';
import StaggerReveal from '../../../components/feature/StaggerReveal';

export default function Benefits() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: 'ri-robot-line',
      title: t('benefit_auto_title'),
      color: '#00cfff',
      points: [
        { icon: 'ri-file-list-3-line', text: t('benefit_auto_p1') },
        { icon: 'ri-bar-chart-box-line', text: t('benefit_auto_p2') },
        { icon: 'ri-notification-3-line', text: t('benefit_auto_p3') },
        { icon: 'ri-delete-bin-line', text: t('benefit_auto_p4') },
      ],
    },
    {
      icon: 'ri-bar-chart-2-line',
      title: t('benefit_ctrl_title'),
      color: '#00ff9d',
      points: [
        { icon: 'ri-dashboard-line', text: t('benefit_ctrl_p1') },
        { icon: 'ri-building-4-line', text: t('benefit_ctrl_p2') },
        { icon: 'ri-user-star-line', text: t('benefit_ctrl_p3') },
        { icon: 'ri-money-dollar-circle-line', text: t('benefit_ctrl_p4') },
      ],
    },
    {
      icon: 'ri-line-chart-line',
      title: t('benefit_growth_title'),
      color: '#00ff9d',
      points: [
        { icon: 'ri-bar-chart-line', text: t('benefit_growth_p1') },
        { icon: 'ri-search-eye-line', text: t('benefit_growth_p2') },
        { icon: 'ri-user-heart-line', text: t('benefit_growth_p3') },
        { icon: 'ri-expand-up-down-line', text: t('benefit_growth_p4') },
      ],
    },
  ];

  return (
    <section id="benefits" className="bg-navy-900 py-14 md:py-24 px-5 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-electric text-xs md:text-sm font-semibold tracking-widest uppercase font-body mb-2 md:mb-3">{t('benefits_label')}</span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">
            {t('benefits_title_1')} <span className="text-electric">{t('benefits_title_2')}</span>
          </h2>
        </div>

        <StaggerReveal
          className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6"
          staggerDelay={130}
        >
          {benefits.map((b) => (
            <div
              key={b.title}
              className="relative rounded-2xl overflow-hidden border border-navy-600 bg-navy-800 hover:border-electric/40 hover:-translate-y-1 transition-all duration-300 p-5 md:p-7"
            >
              <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: `linear-gradient(to right, ${b.color}, transparent)` }}></div>
              <div className="w-11 h-11 md:w-14 md:h-14 flex items-center justify-center rounded-2xl mb-4 md:mb-5 border" style={{ backgroundColor: b.color + '18', borderColor: b.color + '30', color: b.color }}>
                <i className={`${b.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-xl font-bold text-white mb-3 md:mb-5">{b.title}</h3>
              <ul className="space-y-2.5 md:space-y-3">
                {b.points.map((point) => (
                  <li key={point.text} className="flex items-center gap-2.5 text-xs md:text-sm font-body text-white/70">
                    <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: b.color + '12', color: b.color }}>
                      <i className={`${point.icon} text-sm`}></i>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: point.text }} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </StaggerReveal>
      </div>
    </section>
  );
}
